module.exports = __webpack_public_path__ + "assets/images/megaphone.5e17dca43c7b7ffd79785c2928a994c3.png";